import React, { FC } from "react"
import { useCreation } from "ahooks"
import { EChartOption } from "echarts"
import Echart from "@/components/Echart"
import Env from "@util/env"
import "./erectRadio.scss"

type IBarRankProps = {
  data: { value: number; name: string }[]
  // barWidth?: number
  color?: string[]
}

const BarRank: FC<IBarRankProps> = ({
  data,
  // barWidth = 28,
  color = ["#8AF4D2"],
}) => {
  const y1 = data.map((d) => d.name)
  const y2 = data.map((d) => d.value)
  const lData = data.map((d, i) => {
    return {
      name: d.name,
      value: d.value,
    }
  })
  const option = useCreation<EChartOption>(() => {
    return {
      color: color,
      grid: {
        left: "0px",
        right: "0px",
        top: 10,
        bottom: "5px",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          axisTick: { show: false },
          data: y1,
          boundaryGap: true,
          axisLabel: {
            color: "#81A3C3",
            interval: 0,
            lineHeight: 16,
          },
          axisLine: {
            lineStyle: {
              color: "#81A3C3",
            },
          },
        },
      ],
      yAxis: {
        splitNumber: 3,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#81A3C3",
          },
        },
        axisLabel: {
          show: true,
          color: "#81A3C3",
          formatter: function (value: any) {
            return Math.round(value * 10000) / 100 + "%"
          },
        },
      },
      series: [
        {
          type: "bar",
          barMaxWidth: 12 * Env.getScale(),
          barGap: 0,
          data: lData,
        },
      ],
    }
  }, [data])

  return (
    <div className="ct-bar-rank" style={{ height: "100%" }}>
      <Echart option={option} />
    </div>
  )
}

export default BarRank
